(() => {
  const publish = (name, payload = {}) => {
    try {
      if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(name, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
    } catch (error) {
      return;
    }
  };

  const initialiseCatalog = (root) => {
    if (root.dataset.modulloCatalogReady === 'true') return;
    root.dataset.modulloCatalogReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-modullo-catalog-card]'));
    const filters = Array.from(root.querySelectorAll('[data-modullo-catalog-filter]'));
    const count = root.querySelector('[data-modullo-catalog-count]');
    const noResults = root.querySelector('[data-modullo-catalog-empty]');

    const matches = (card, key, value) => {
      if (value === 'all') return true;
      return (card.dataset[key] || '').split(/\s+/).includes(value);
    };

    const applyFilters = () => {
      const active = Object.fromEntries(filters.map((filter) => [filter.dataset.modulloCatalogFilter, filter.value]));
      let visible = 0;
      cards.forEach((card) => {
        const show = Object.entries(active).every(([key, value]) => matches(card, key, value));
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = String(visible);
      if (noResults) noResults.hidden = visible !== 0;
    };

    filters.forEach((filter) => {
      filter.addEventListener('change', () => {
        applyFilters();
        publish('ecoflusso_modullo_catalog_filter', {
          filter_name: filter.dataset.modulloCatalogFilter,
          filter_value: filter.value,
        });
      });
    });

    root.querySelector('[data-modullo-catalog-reset]')?.addEventListener('click', () => {
      filters.forEach((filter) => {
        filter.value = 'all';
      });
      applyFilters();
      publish('ecoflusso_modullo_catalog_filter_reset');
    });

    cards.forEach((card) => {
      card.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          publish('ecoflusso_modullo_catalog_select', {
            family: card.dataset.system || '',
            product_handle: card.dataset.productHandle || '',
          });
        });
      });
    });

    applyFilters();
  };

  const initialiseProduct = (root) => {
    if (root.dataset.modulloProductReady === 'true') return;
    root.dataset.modulloProductReady = 'true';
    root.querySelectorAll('[data-modullo-product-cta]').forEach((link) => {
      link.addEventListener('click', () => {
        publish('ecoflusso_modullo_product_cta', {
          product_handle: root.dataset.productHandle || '',
          action: link.dataset.modulloProductCta || '',
        });
      });
    });
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-modullo-catalog]').forEach(initialiseCatalog);
    scope.querySelectorAll('[data-modullo-product]').forEach(initialiseProduct);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
